<template>
  <loader :task="task" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IntegrationPreset } from '@/iam/types';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import repository from './integration-preset-repository';

interface Data {
  task: Promise<IntegrationPreset[]>|null,
}

export default defineComponent({
  emits: ['loaded'],
  components: {
    Loader,
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    load(): void {
      this.task = repository.findAll();
      this.task.then((integrationPresets: IntegrationPreset[]) => {
        this.$emit('loaded', integrationPresets);
      });
    },
  },
  created(): void {
    this.load();
  },
});
</script>
